import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Content, ContentWrapper } from '../../components/Content';
import { cards as cardData, phoneImg } from './data';
import * as Styled from './Hero.styles';
import HeroCard from './HeroCards';

const Hero = () => {
  const { t } = useTranslation();

  const labels = useMemo(
    () => [
      t('homeHero.labels.onlyRealUsers'),
      t('homeHero.labels.noAlgorithm'),
      t('homeHero.labels.noDataMisuse'),
    ],
    [t],
  );

  const cards = useMemo(
    () =>
      cardData.map((card) => ({
        ...card,
        title: t(`homeHero.cards.${card.id}.title`),
        text: t(`homeHero.cards.${card.id}.text`),
        postedIn:
          card.id === 'stayUpdated'
            ? t('homeHero.cards.stayUpdated.postedIn')
            : '',
      })),
    [t],
  );

  return (
    <Styled.Hero id="hero">
      <ContentWrapper>
        <Content
          labels={labels}
          title={t('homePageTitle')}
          text={t('homePageText')}
          titleVariant="h1"
        />

        <Styled.Bottom>
          <Styled.PhoneBlock>
            <Styled.Phone src={phoneImg.src} alt={t('homeHero.phoneAlt')} />
            <Styled.Logo variant="logo" />
          </Styled.PhoneBlock>

          <Styled.Cards>
            {cards.map((card) => (
              <HeroCard key={card.id} card={card} />
            ))}
          </Styled.Cards>
        </Styled.Bottom>

        <Styled.Decors>
          <Styled.Circle />
          <Styled.Circle />
        </Styled.Decors>
      </ContentWrapper>
    </Styled.Hero>
  );
};

export default Hero;
